import React from 'react';
import './App.css';
import {   BrowserRouter,   Route,   Routes } from "react-router-dom";
import { AppProvider } from './context/AppContext';
import Home from './pages/Home';
import Challenges from './pages/Challenges';
import Resources from './pages/Resources';
import Login from './pages/Login';
import SingleChallenge from './pages/SingleChallenge';
import SingleResource from './pages/SingleResource';
import Meetings from './pages/Meetings';
import SingleMeeting from './pages/SingleMeeting';
import Dashboard from "./admin/scenes/dashboard";
import ResourcesAdmin from "./admin/scenes/resources/Resources";
import ChallengesAdmin from "./admin/scenes/challenges/Challenges";
import NewResource from './admin/scenes/resources/NewResource';
import EditResource from './admin/scenes/resources/EditResource';
import DeleteResource from './admin/scenes/resources/DeleteResource';
import AddChallenge from './admin/scenes/challenges/AddChallenge';
import EditChallenge from './admin/scenes/challenges/EditChallenge';
import DeleteChallenge from './admin/scenes/challenges/DeleteChallenge';
import CompleteProfile from './pages/CompleteProfile';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import Users from './admin/scenes/users/Users';
import Page404 from './pages/Page404';
import Tasks from './admin/scenes/tasks/Tasks';
import AddTask from './admin/scenes/tasks/AddTask';
import DeleteTask from './admin/scenes/tasks/DeleteTask';
import EditTask from './admin/scenes/tasks/EditTask';
import SubmittedTasks from './admin/scenes/submitted_tasks/SubmittedTasks';
import SingleTask from './pages/SingleTask';
import ForgetPassword from './pages/ForgetPassword';
import { AuthContextProvider } from './context/AuthContext';
import EventsAdmin from './admin/scenes/events/Events';
import DeleteEvent from './admin/scenes/events/DeleteEvent';
import EditEvent from './admin/scenes/events/EditEvent';
import AddEvent from './admin/scenes/events/AddEvent';
import WhoWeArePage from './pages/WhoWeArePage';
import FaqPage from './pages/FaqPage';
import ContactUsPage from './pages/ContactUsPage';


const App = () => {
  return (
    <div  >
    <AppProvider>
    <AuthContextProvider>
{/*     
    <BrowserRouter>

   
    <Routes>

         <Route
                path="/"
                element={
                  <Home />
                }
              />

         <Route
                path="/meetings"
                element={
                  <Meetings />
                }
              />

         <Route
                path="/single-meeting/:meetingId"
                element={
                  <SingleMeeting />
                }
              />

         <Route
                path="/initiatives"
                element={
                  <Challenges />
                }
              />

         <Route
                path="/single-challenge/:challengeId"
                element={
                  <SingleChallenge />
                }
              />

         <Route
                path="/blog"
                element={
                  <Resources />
                }
              />

         <Route
                path="/whoweare"
                element={
                  <WhoWeArePage />
                }
              />

         <Route
                path="/faq"
                element={
                  <FaqPage />
                }
              />

         <Route
                path="/contact-us"
                element={
                  <ContactUsPage />
                }
              />

         <Route
                path="/single-resource/:resourceId"
                element={
                  <SingleResource />
                }
              />

         <Route
                path="/single-task/:taskId"
                element={
                  <SingleTask />
                }
              />


         <Route
                path="/login"
                element={
                  <Login />
                }
              />

         <Route
                path="/profile"
                element={
                  <Profile />
                }
              />


         <Route
                path="/edit-profile"
                element={
                  <EditProfile />
                }
              />

         <Route
                path="/complete-profile"
                element={
                  <CompleteProfile />
                }
              />

         <Route
                path="/forget-password"
                element={
                  <ForgetPassword />
                }
              />

         <Route
                path="/*"
                element={
                  <Page404 />
                }
              />

          { /* ADMIN DASHBOARD */  }
      
   
{/* 
            <Route path="/admin" element={<Dashboard />} />

              <Route path="/admin/events" element={<EventsAdmin />} />

              <Route path="/admin/addEvent" element={<AddEvent />} />

              <Route path="/admin/updateEvent/:eventId" element={<EditEvent />} />

              <Route path="/admin/deleteEvent/:eventId" element={<DeleteEvent />} />

              <Route path="/admin/resources" element={<ResourcesAdmin />} />

              <Route path="/admin/addResource" element={<NewResource />} />

              <Route path="/admin/updateResource/:resourceId" element={<EditResource />} />

              <Route path="/admin/deleteResource/:resourceId" element={<DeleteResource />} />

              <Route path="/admin/challenges" element={<ChallengesAdmin />} />

              <Route path="/admin/addChallenge" element={<AddChallenge />} />

              <Route path="/admin/updateChallenge/:challengeId" element={<EditChallenge />} />

              <Route path="/admin/deleteChallenge/:challengeId" element={<DeleteChallenge />} />

              <Route path="/admin/users" element={<Users />} />

              <Route path="/admin/tasks" element={<Tasks />} />
              <Route path="/admin/addTask" element={<AddTask />} />
              <Route path="/admin/deleteTask/:taskID" element={<DeleteTask />} />
              <Route path="/admin/editTask/:taskID" element={<EditTask />} />

              <Route path="/admin/tasks-submitted" element={<SubmittedTasks />} />


    </Routes>

    </BrowserRouter>  */}

  
    </AuthContextProvider>
    </AppProvider>
    </div>
  )
}

export default App